import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Home from "@/pages/Home";
import Watch from "@/pages/Watch";
import About from "@/pages/About";
import Shorts from "@/pages/Shorts";
import Layout from "@/components/Layout";
import RouteTracker from "@/components/RouteTracker";

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <RouteTracker />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/watch/:videoId" element={<Watch />} />
            <Route path="/shorts" element={<Shorts />} />
            <Route path="/sobre" element={<About />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
